import { __decorate, __metadata } from "tslib";
import { action, observable } from 'mobx';
var AppStore = (function () {
    function AppStore() {
        var _this = this;
        this.alerts = [];
        this.currentStep = 0;
        this.currentState = 0;
        this.counter = 0;
        this.previousStep = function () {
            _this.clearAlerts();
            _this.currentStep--;
        };
        this.nextStep = function () {
            _this.clearAlerts();
            _this.currentStep++;
        };
        this.gotoStep = function (step) {
            _this.clearAlerts();
            _this.currentStep = step;
        };
        this.gotoState = function (state) {
            _this.currentState = state;
        };
    }
    AppStore.prototype.addAlert = function (alert) {
        alert.id = this.counter;
        this.alerts.push(alert);
        this.counter++;
    };
    AppStore.prototype.removeAlert = function (id) {
        this.alerts = this.alerts.filter(function (alert) {
            return alert.id !== id;
        });
    };
    AppStore.prototype.clearAlerts = function () {
        this.alerts = [];
    };
    __decorate([
        observable,
        __metadata("design:type", Array)
    ], AppStore.prototype, "alerts", void 0);
    __decorate([
        observable,
        __metadata("design:type", Number)
    ], AppStore.prototype, "currentStep", void 0);
    __decorate([
        observable,
        __metadata("design:type", Number)
    ], AppStore.prototype, "currentState", void 0);
    __decorate([
        action,
        __metadata("design:type", Object)
    ], AppStore.prototype, "previousStep", void 0);
    __decorate([
        action,
        __metadata("design:type", Object)
    ], AppStore.prototype, "nextStep", void 0);
    __decorate([
        action,
        __metadata("design:type", Object)
    ], AppStore.prototype, "gotoStep", void 0);
    __decorate([
        action,
        __metadata("design:type", Object)
    ], AppStore.prototype, "gotoState", void 0);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AppStore.prototype, "addAlert", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], AppStore.prototype, "removeAlert", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AppStore.prototype, "clearAlerts", null);
    return AppStore;
}());
export { AppStore };
//# sourceMappingURL=AppStore.js.map